import * as React from "react";
import { Form, Message } from "semantic-ui-react";
import { validation } from "../../utils/validation/validation";

interface ICurrencyInputProps {
  onChange(value: any): void;
  checkRange?: boolean;
  min: number;
  max: number;
  validationMessage: string;
  cssClasses: string;
  placeHolder: string;
}

interface ICurrencyInputState {
  value: number | null;
  showError: boolean;
}

export class CurrencyInput extends React.Component<
  ICurrencyInputProps,
  ICurrencyInputState
> {
  state: ICurrencyInputState;

  constructor(props: ICurrencyInputProps) {
    super(props);

    this.state = { value: null, showError: false };
  }

  render() {
    return (
      <>
        <Form.Input
          icon="pound"
          iconPosition="left"
          placeholder={this.props.placeHolder}
          className={this.props.cssClasses}
          type="number"
          min="1"
          error={this.state.showError}
          onChange={(event: any) => {
            let value : number | null = null;
            if (event.target.value) value = parseInt(event.target.value);

            this.setState({ value: value });
            this.props.onChange(value);
          }}
          onBlur={(_: any) => {
            if (this.props.checkRange) {
              if (
                !validation.isInRange(
                  this.state.value,
                  this.props.min,
                  this.props.max,
                  false
                )
              ) {
                this.setState({
                  showError: true
                });
              } else {
                this.setState({
                  showError: false
                });
              }
            }
          }}
        />

        {this.state.showError && (
          <Message negative>{this.props.validationMessage}</Message>
        )}
      </>
    );
  }
}

